export default __webpack_public_path__ + "images/abffdde69a7d7f288daf859b725890e9-baltimore_mobile.webp";